export const TIME_LEFT = 'adTimeLeft';
export const FREEWHEEL_AD = 'freewheelAd';
export const FREEWHEEL_DEFAULT_QUERIES = '?prof=000000:ftv_html5&nw=000000&caid=ABC123&vdur=312[…]ml_lit_nowrapper,text/html_no_iframe&w=1920&h=650&flag=+cmpn';

export const FREEWHEEL_AD_CDN = 'https://mssl.fwmrm.net/libs/adm/7.8.0/AdManager.js';
export const AD_COUNTDOWN_TIME = 5;
export const MID_CP_MARGIN = 0.20;
